import React from "react";

export default function FAQBlock({ data }) {
  const items = data.items || [
    { question: "Question?", answer: "Answer goes here." },
  ];

  return (
    <div style={{ marginTop: "20px", color: "white" }}>
      <h2>{data.title || "FAQ"}</h2>

      {items.map((faq, i) => (
        <div
          key={i}
          style={{
            background: "#222",
            padding: "15px",
            marginTop: "10px",
            borderRadius: "10px",
          }}
        >
          <strong>{faq.question}</strong>
          <p style={{ opacity: 0.8 }}>{faq.answer}</p>
        </div>
      ))}
    </div>
  );
}
